import script from "./productCondiments.vue?vue&type=script&lang=ts&setup=true"
export * from "./productCondiments.vue?vue&type=script&lang=ts&setup=true"

import "./productCondiments.vue?vue&type=style&index=0&id=76c3978a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76c3978a"]])

export default __exports__